import ReactECharts from 'echarts-for-react';
import type React from 'react';
import { forwardRef } from 'react';

import { Industry } from '@/enums/Industry';
import { getIndustryResultCircleColors } from '@/utils/industryColors';

interface SDGData {
  id: number;
  title: string;
  subtitle: string;
  score: number;
  description: string;
}

interface SDGRadarChartProps {
  sdgData: SDGData[];
  style?: React.CSSProperties;
  industry?: Industry;
}

export const getRadarChartOption = (
  sdgData: SDGData[],
  industry?: Industry,
) => {
  return {
    radar: {
      indicator: sdgData
        .slice()
        .reverse()
        .map((sdg) => ({
          name: String(sdg.id).padStart(2, '0'),
          max: 30,
        })),
      radius: ['30%', '85%'],
      splitNumber: 6,
      startAngle: 90 - (360 / 17) * 16,
      splitLine: {
        lineStyle: {
          color: '#ffffff',
        },
      },
      axisLine: {
        show: false,
      },
      splitArea: {
        show: true,
        areaStyle: {
          color: '#999999',
        },
      },
      name: {
        textStyle: {
          color: '#000000',
          fontSize: 12,
        },
      },
    },
    series: [
      {
        type: 'radar',
        data: [
          {
            value: sdgData
              .slice()
              .reverse()
              .map((sdg) => sdg.score),
            areaStyle: {
              color: getIndustryResultCircleColors(industry!).bgCenter,
            },
            lineStyle: {
              color: getIndustryResultCircleColors(industry!).bgCenter,
            },
            itemStyle: {
              color: getIndustryResultCircleColors(industry!).bgCenter,
            },
          },
        ],
      },
    ],
    backgroundColor: 'transparent',
    animation: false,
  };
};

export const SDGRadarChart = forwardRef<ReactECharts, SDGRadarChartProps>(
  function SDGRadarChart({ sdgData, style, industry }, ref) {
    const echartsOption = getRadarChartOption(sdgData, industry);

    return (
      <ReactECharts
        ref={ref}
        option={echartsOption}
        opts={{
          renderer: 'canvas',
          devicePixelRatio: 5,
        }}
        style={style}
      />
    );
  },
);
